import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleSelectSearchState } from "../../HandleSlice/HandleSlice";

const SelectSearch = (props) => {
  const [value, setValue] = useState("");
  const [option, setOption] = useState([]);
  const [optionsStyle, setOptionsStyle] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const firstTime = useRef(false);
  const hasPageBeenRendered = useRef(false);
  const dataState = useSelector((state) => state.hamberger.selectSearchState);
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.pageType === "edit") {
      const key = props.item.key;
      const arrayOptions = props.selectSearchData;
      const filterNewOptions = arrayOptions[key];

      const array = filterNewOptions.filter((item) => {
        return +item.value === +props.editDataValue;
      });
      setValue(array.length === 1 ? array[0].label : "");
      setSelectedValue(array.length === 1 ? array[0].label : "");
    }
  }, [props]);

  useEffect(() => {
    setOption(props.selectSearchData[props.item.key]);
  }, []);

  function inputblurHandler() {
    document.body.addEventListener("click", (event) => {
      if (!event.target.matches(`.${props.matchpointId}`))
        setOptionsStyle(false);
    });
  }

  useEffect(() => {
    if (props.item.key === dataState.split("-")[0] && firstTime) {
      setValue("");
      setSelectedValue("");
    }
    firstTime.current = true;
  }, [dataState]);

  useEffect(() => {
    if (!optionsStyle && hasPageBeenRendered.current) {
      setValue(selectedValue);
    }
    hasPageBeenRendered.current = true;
  }, [optionsStyle]);

  function onChange(event) {
    setValue(event.target.value);
    const array = props.selectSearchData[props.item.key].filter((item) => {
      return item.label.search(`${event.target.value}`) !== -1;
    });
    setOption(array);
  }

  function selectOption(event) {
    setValue(event.target.innerText);
    setOption(props.selectSearchData[props.item.key]);
    if (props.HasManyInputData) {
      props.HasManyInputData(props.index, props.HasManyKey, event.target.value);
    } else {
      let object = props.inputData;
      object[props.item.key] = event.target.id;
      props.setInputData(object);
    }
    setSelectedValue(event.target.innerText);
    setOptionsStyle(false);
    let relationSelectOptions = [];
    let obj = props.selectSearchData;
    if (props.item.relation) {
      axios
        .get(`${props.item.route}${event.target.id}`)
        .then((res) => {
          for (let option of res.data.data) {
            relationSelectOptions.push({
              label: option.label,
              value: option.value,
            });
          }
          if (props.item.relation) {
            dispatch(
              handleSelectSearchState(
                `${props.item.relation}-${relationSelectOptions[0].label}`,
              ),
            );
          }
          obj[props.item.relation] = relationSelectOptions;
          props.setSelectSearchData(obj);
        })
        .then(() => {
          props.handleForceupdateMethod();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  useEffect(() => {
    setOption(props.selectSearchData[props.item.key]);
  }, [props.selectSearchData[props.item.key]]);

  // useEffect(() => {
  //     if (props.pageType === "edit" && props.item.route !== undefined) {
  //         console.log(`${props.item.route}${props.inputData[props.item.key]}`)
  //         axios
  //             .get(`${props.item.route}${props.inputData[props.item.key]}`).then((res) => {setOption(res.data.data)})
  //     }
  // }, [props.item]);

  return (
    <div className="w-full relative rounded-md col-span-full sm:col-auto">
      <div className="">
        <input
          className={`h-[38px] dark:bg-[#ffffffdd] border border-edit_input_border ${props.item.disabled ? "text-edit_input_text" : "edit_input_text_disabled"} dark:text-[#555555] rounded-[4px] px-3 w-full ${props.matchpointId}`}
          value={value}
          onChange={onChange}
          onFocus={() => {
            setOptionsStyle(true);
          }}
          disabled={props.item.disabled}
          onBlur={inputblurHandler}
        />
        {optionsStyle && (
          <ul className="w-full bg-white absolute max-h-[200px] overflow-y-scroll top-38 border border-edit_input_border shadow-xl z-[50]">
            {option.map((item) => {
              return (
                <li
                  key={item.value}
                  id={item.value}
                  className="w-full py-[5px] px-[10px] hover:bg-[#9cc8cae1]"
                  onClick={selectOption}
                >
                  {item.label}
                </li>
              );
            })}
          </ul>
        )}
      </div>
      <div className="mt-2 text-[.8rem] text-edit_input_validation">
        {props.children}
      </div>
    </div>
  );
};

export default SelectSearch;
